module.exports = /*#__PURE__*/JSON.parse('{"version":"2026-08-05"}')